export class OrgBrowserView {
    orgId: number;
    orgName: string;
    orgShortName: string;
    orgEffectiveDate: Date;
    orgTerminationDate: Date;
    isActive: boolean;
    parentOrgId: number;
    orgIPV: string;
    orgIPVString: string;
    expanded: boolean;
    selected: boolean;
    includeDownline: boolean;
    constructor() {
        this.expanded = false;
        this.selected = false;
        this.includeDownline = false;
    }
}